export default __webpack_public_path__ + "static/media/gallery-wip-grenade_01.bf615899.jpg";